(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('PlanningEventsService', PlanningEventsService);

    PlanningEventsService.$inject = ['$resource'];

    function PlanningEventsService($resource) {

        var resourceUrl = 'api/plan/';

        return $resource(
            resourceUrl,
            {
                planLabel: '@planLabel',
                startTime: '@startTime',
                endTime: '@endTime',
                minDuration: '@minDuration',
                windowDuration: '@windowDuration',
                eventCollectionsLabel : '@eventCollectionsLabel',
                timeSlot :'@timeSlot',
                backupTimeSlot :'@backupTimeSlot',
                isCoordBurstAutomatic:'@isCoordBurstAutomatic',
            },
            {
                'addEvent': {
                    url: resourceUrl + 'event/add',
                    method: 'PUT',
                },
                'updateEvent': {
                    url: resourceUrl + 'event/update',
                    method: 'PUT',
                },
                'deleteEvent': {
                    url: resourceUrl + 'event/delete',
                    method: 'PUT',
                },
                'generateAttDist': {
                    url: resourceUrl + 'generateAttDist',
                    method: 'PUT',
                },
                'generateAutoEmcPrefNoisy': {
                    url: resourceUrl + 'generateAutoEmcPrefNoisy',
                    method: 'PUT',
                },
                'generateAutoEmcMandQuiet': {
                    url: resourceUrl + 'generateAutoEmcMandQuiet',
                    method: 'PUT',
                },
                'guaranteeEmcPrefNoisy': {
                    url: resourceUrl + 'guaranteeEmcPrefNoisy',
                    method: 'PUT',
                },
                'guaranteeEmcMandQuiet': {
                    url: resourceUrl + 'guaranteeEmcMandQuiet',
                    method: 'PUT',
                },
                'guaranteeEmcMandQuietPrevious': {
                    url: resourceUrl + 'guaranteeEmcMandQuietPrevious',
                    method: 'PUT',
                },
                'guaranteeIsCoordBurst': {
                    url: resourceUrl + 'guaranteeIsCoordBurst',
                    method: 'PUT',
                },
                'finishedEmcPrefNoisy': {
                    url: resourceUrl + 'finishedEmcPrefNoisy',
                    method: 'PUT',
                },
                'finishedIsCoordBurst': {
                    url: resourceUrl + 'finishedIsCoordBurst',
                    method: 'PUT',
                },
                'finishedEmcMandQuiet': {
                    url: resourceUrl + 'finishedEmcMandQuiet',
                    method: 'PUT',
                },
                'updateEventCollection': {
                    url: resourceUrl + 'updateEvents',
                    method: 'PUT'
                },
                'setValidityPeriod': {
                    url: resourceUrl + 'setValidityPeriod',
                    method: 'PUT'
                },
                'getEventSchemas': {
                    url: resourceUrl + 'event-schemas',
                    method: 'GET',
                    isArray: true
                },
                'getProfiles': {
                    url: resourceUrl + 'profiles',
                    method: 'GET',
                    isArray: true
                }, 'getSOCEvents': {
                    method: 'GET',
                    url: resourceUrl + 'soc-events',
                    isArray: true
                }, 'getSOCEventSets': {
                    method: 'GET',
                    url: resourceUrl + 'soc-event-sets'
                },'expandSOCEvents': {
                    method: 'PUT',
                    url:  resourceUrl +'expand-soc-events',
                }
            });
    }
})();
